import "common/common.scss";
import React from "react";
import { InsGainLossIndicator } from "components/widgets/kpi/";
import { getVariationClassName } from "components/widgets/table/cell/helpers/variation-helper";
import { VariationFormat } from "store/current-dashboard/types";
export const EsgRatingVariationCellRenderer = (props) => {
    const variation = props.value, variationClassName = getVariationClassName(variation);
    return React.createElement("span", { className: `variation-cell ${variationClassName}` },
        React.createElement(InsGainLossIndicator, { oldValue: 0, newValue: variation, variationSettings: { format: VariationFormat.esgVariation, gainLoss: { gain: 0, loss: 0 }, showPrefix: true } }));
};
